var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auto-slider", class: _vm.rootClasses }, [
    _c(
      "div",
      { ref: "slider", staticClass: "auto-slider--container swiper-container" },
      [
        _c(
          "div",
          { staticClass: "auto-slider--slider-wrapper swiper-wrapper" },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5931be95", { render: render, staticRenderFns: staticRenderFns })
  }
}